import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openPicker() {
    try {
      if (!this.element.showPicker) return

      this.element.showPicker()
    } catch (error) {
      if (!(error instanceof DOMException)) throw error
    }
  }
}
